// Polyfill AbortSignal.timeout if missing
if (
    typeof AbortSignal !== 'undefined' &&
    typeof (AbortSignal as any).timeout !== 'function'
) {
    ;(AbortSignal as any).timeout = function timeout(ms: number): AbortSignal {
        const c = new AbortController()
        const id = setTimeout(
            () => c.abort(new DOMException('Timeout', 'TimeoutError')),
            ms,
        )
        c.signal.addEventListener('abort', () => clearTimeout(id), {
            once: true,
        })
        return c.signal
    }
}
